import React from 'react'
import { createRoot } from 'react-dom/client'
import { DemoEntryPanel } from '../src/tg/demo/components/DemoEntryPanel'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('tg-demo-root')
  if (!container) return

  const root = createRoot(container)
  root.render(<DemoEntryPanel />)
})
